module.exports = __webpack_public_path__ + "assets/img/20.47a59651.png";